// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"832":"2a16730ed108114a","4005":"747b7a754541d5d0","5748":"0bea4818fe9ca460"}[chunkId] + ".css";
};